export default "__VITE_ASSET__BpSvnlcB__"